import {Link} from 'react-router-dom';
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Login from "../login/Login";
import Button from "@mui/material/Button";

import CheckIcon from '@mui/icons-material/Check';

function RepositoryAcceptedForPublish(props) {
    return (
        <React.Fragment>
            <main>
                <div>
                    {props.authString
                        ? <MainContent authRole={props.authRole} />
                        : <Login setAuthString={props.setAuthString} />
                    }
                </div>
            </main>
        </React.Fragment>
    )
}

const MainContent = ({authRole}) => {
    return (
        <React.Fragment>
            <Box className="repository-accepted-box">
                <CheckIcon className="green-icon" />
                <br />
                <Typography variant="body2">This data repository submission has been accepted to be published!
                    {authRole === 'publisher'
                        ? ' You can publish it from the repository preview page.'
                        : ' A publisher will need to publish it from the repository preview page.'}
                </Typography>
                <br />
                <div>
                    <Link to={'/repositories/management'}>
                        <Button size="small" variant="contained" fullWidth className="large-button">Back to Management Home</Button>
                    </Link>
                </div>
            </Box>
        </React.Fragment>
    )
}

export default RepositoryAcceptedForPublish;